module.exports = __webpack_public_path__ + "img/red-cross.cf3cd468.png";